import { render, staticRenderFns } from "./ProjectBilling.vue?vue&type=template&id=5550b597"
import script from "./ProjectBilling.vue?vue&type=script&lang=js"
export * from "./ProjectBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports